'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dot = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  50% {color: transparent;}\n'], ['\n  50% {color: transparent;}\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  animation: 1s ', ' infinite;\n  &:nth-child(1) {\n    animation-delay: 0ms;\n  }\n  &:nth-child(2) {\n    animation-delay: 250ms;\n  }\n  &:nth-child(3) {\n    animation-delay: 500ms;\n  }\n'], ['\n  animation: 1s ', ' infinite;\n  &:nth-child(1) {\n    animation-delay: 0ms;\n  }\n  &:nth-child(2) {\n    animation-delay: 250ms;\n  }\n  &:nth-child(3) {\n    animation-delay: 500ms;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var blink = (0, _styledComponents.keyframes)(_templateObject);
var Dot = exports.Dot = _styledComponents2.default.span(_templateObject2, blink);